export default __webpack_public_path__ + "static/media/logo2.84e3d3b3.png";